import { FunctionComponent, useState } from "react";
import { ReferenceContext } from "providers/ReferenceProvider";
import styles from "./about.module.scss";
import Title from "primitives/Title";
import Description from "primitives/Description";
import Card from "components/Card";
import { NavigateBefore, NavigateNext } from "@material-ui/icons";
import aboutCards from "data/AboutData";
import Button from "primitives/Button/Button";
import UnderTitle from "primitives/UnderTitle";

const About: FunctionComponent = () => {
  const [currentPage, setCurrentPage] = useState(0);
  const onNavigateBefore = () => {
    setCurrentPage((prevPage) => {
      if (prevPage === 0) {
        return aboutCards.length - 1;
      }
      return prevPage - 1;
    });
  };

  const onNavigateNext = () => {
    setCurrentPage((prevPage) => {
      if (prevPage === aboutCards.length - 1) {
        return 0;
      }
      return prevPage + 1;
    });
  };

  const getCardPosition = (index: number): string => {
    if (index === currentPage + 1) {
      return "nextCard";
    } else if (index === currentPage - 1) return "prevCard";
    else if (index === currentPage) return "activeCard";
    return "";
  };

  return (
    <ReferenceContext.Consumer>
      {(refs) => (
        <div className={styles.container} ref={refs.aboutRef}>
          <div>
            <Title>About me</Title>
            <Description>
              Im an software engineer recently graduated from University of Oslo
              with a M.sc grad in computer science.
            </Description>
            <Description>
              I am an active person with a great engagement in innovation and
              technology.
            </Description>
          </div>
          <div className={styles.mainContentWrapper}>
            <UnderTitle>{aboutCards[currentPage].title}</UnderTitle>
            <div className={styles.mainContainer}>
              <Button onClick={onNavigateBefore}>
                <NavigateBefore fontSize={"large"} />
              </Button>
              <div className={styles.cardContainer}>
                {aboutCards.map((card, index) => {
                  let position = getCardPosition(index);

                  return (
                    <Card
                      img={card.image}
                      position={position}
                      key={index}
                    ></Card>
                  );
                })}
              </div>
              <Button onClick={onNavigateNext}>
                <NavigateNext fontSize={"large"} />
              </Button>
            </div>
            <div>
              <Description className={styles.cardDescription}>
                {aboutCards[currentPage].description}
              </Description>
            </div>
          </div>
        </div>
      )}
    </ReferenceContext.Consumer>
  );
};

export default About;
